import { Dialog } from "@app/domains/shared/design-system";
import { useIsMobile } from "@app/domains/shared/hooks";
import React from "react";

export const DialogContent: React.FC = ({ children }) => {
  const isMobile = useIsMobile();
  return isMobile ? <>{children}</> : <Dialog.Body>{children}</Dialog.Body>;
};
